export default __webpack_public_path__ + "static/media/map_share_banner.f5071c11.jpg";